import { Button } from "../../../../components/Button/Button.tsx";

export const SettingsClickableItem = ({
  title,
  value,
  buttonLink,
  buttonText,
}: {
  title: string;
  value: string | null;
  buttonLink: string;
  buttonText: string;
}) => (
  <div className="py-200 flex-row justify-between items-center">
    <div className="flex-col gap-100">
      <div className="body-md-semibold">{title}</div>
      <div className="text-secondary">{value}</div>
    </div>
    <Button
      variant="secondary"
      size="md"
      onClick={() => window.open(buttonLink, "_blank")}
    >
      {buttonText}
    </Button>
  </div>
);
